import { ReactComponent as FacebookIcon } from "../../../icons/facebook.svg";
import { ReactComponent as XIcon } from "../../../icons/x.svg";
import { ReactComponent as LinkedInIcon } from "../../../icons/linkedin.svg";
import "./Footer.css";

function Footer(){
    return (
    <section className="footer">
      <hr className="footer-seperator" />
      <section className="footer-info">
        <section className="footer-info-left">
          <section className="footer-info__name">
             <a href="https://sentryti.com"> 
                Sentry Technologies
             </a>
          </section>        
        </section>
        <section className="footer-info-center">
          <section className="footer-info__email">
            <a href="/privacy-policy"> 
                Privacy Policy
             </a>
          </section>
        </section>
        <section className="footer-info-right">
          <section className="footer-info__number">
            <label>
                <a href="https://www.facebook.com/SentryTechnologies" title="Follow on Facebook" target="_blank" rel="noopener noreferrer" className="footer-link">
                  <FacebookIcon/>
                </a>{" "}
                <a href="https://x.com/Sentryti" title="Follow on X" target="_blank" rel="noopener noreferrer" className="footer-link">
                  <XIcon/>
                </a>{" "}
                <a href="https://www.linkedin.com/company/sentry-technologies-inc" title="Follow on LinkedIn" target="_blank" rel="noopener noreferrer" className="footer-link">
                  <LinkedInIcon/>
                </a>
            </label>
          </section>
        </section>
      </section>
      <hr className="footer-seperator" />
    </section>
  )
}

export default Footer;